export const claimStatus = {
  N: 'New',
  C: 'Closed',
  A: 'Confirmed',
  S: 'Submitted',
  V: 'Void',
  X: 'Cancel'
}

export const salutation = {
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MDM: 'Mdm',
  DR: 'Dr',
  OTH: 'Others'
}

export const claimantStatus = {
  I: 'Individual',
  E: 'Entity'
}
